import React from 'react';
import '../App.css';

const Registro = () => {
  return (
    <section className="registro-page">
      <h2>Registro</h2>
      <form className="registro-form-placeholder">
        <input type="text" placeholder="Nombre completo" required />
        <input type="email" placeholder="Correo electrónico" required />
        <input type="password" placeholder="Contraseña" required />
        <input type="password" placeholder="Repetir contraseña" required />
        <button className="registro-btn">Registrarse</button>
      </form>
      <div className="registro-extra-links">
        <a href="/login">¿Ya tienes cuenta? Ingresar</a>
      </div>
    </section>
  );
};

export default Registro; 